export const state = {
  surveyAccountId: null,
  surveyUserId: null,
  surveyFavoriteUnitId: null,
  surveyToken: null,
  surveySelectedUnit: null,
  surveyPublicDetails: null
}
